(function () {

  'use strict';

  angular
    .module('specsguardApp')
    .component('sgElementChangelog', {
      templateUrl: 'app-legacy/components/sg-element-changelog/element-changelog.html',
      bindings: {
        logs: '<',
        tooltip: '<',
        changes: '<'
      },
      controllerAs: '$ctrl',
      controller: function () {
        const vm = this;

        function getFullName(user) {
          let fullName = '';

          if (user.nameFirst) {
            fullName += user.nameFirst[0].toUpperCase() + user.nameFirst.slice(1);
          }
          if (user.nameInfix) {
            fullName += ' ' + user.nameInfix;
          }
          if (user.nameLast) {
            fullName += ' ' + user.nameLast[0].toUpperCase() + user.nameLast.slice(1);
          }
          return fullName.trim();
        }

        vm.$onChanges = () => {
          vm.items = [];
          if (vm.changes && vm.changes.overview) {
            vm.items = vm.changes.overview;
          } else {

            if (!vm.logs) {
              return;
            }

            vm.logs.forEach((log) => {
              if (log.userId && log.text) {
                let userRecord = vm.items.find((change) => change.user._id === log.userId._id);
                if (userRecord) {
                  userRecord.log.push(log);
                } else {
                  log.userId.fullName = log.userId.fullName ? log.userId.fullName : getFullName(log.userId);
                  vm.items.push({
                    user: log.userId,
                    log: [log],
                  });
                }
              }
            });

            //set count
            for (let item of vm.items) {
              item.count = item.log.length;
            }
          }
        };
      }
    });
})();
